import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import { getListServicios } from '../_apis_/dagpacket-recargasServicios';

const UtilidadesContext = createContext();

const UtilidadesProvider = ({ children }) => {
  const [isShowingNewDashboard, setIsShowingNewDashboard] = useState(false);
  const [utilidadesPorServicioAdmin, setUtilidadesPorServicioAdmin] = useState({
    envios: 0,
    recargas: 0,
    ventaEmpaques: 0,
    pagoServicios: 0
    // repartoMultimarcas: 0   //TODO! descomentar para agregar a utilidades
  });

  const [utilidadesPorServicioNonAdmin, setUtilidadesPorServicioNonAdmin] = useState({
    envios: 0,
    recargas: 0,
    ventaEmpaques: 0,
    pagoServicios: 0
    // repartoMultimarcas: 0   //TODO! descomentar para agregar a utilidades
  });
  const [codigosDigitales, setCodigosDigitales] = useState([]);

  useEffect(() => {
    const getServicios = async () => {
      const listServicios = await getListServicios();
      setCodigosDigitales(listServicios.filter((serv) => serv.category === 'Cdigos Digitales').map((serv) => serv.id));
    };
    getServicios();
  }, []);

  const getUtilidadesPorServicio = (isAdmin) => (isAdmin ? utilidadesPorServicioAdmin : utilidadesPorServicioNonAdmin);

  /**
   * Actualiza las utilidades por servicio para el administrador o no administrador.
   *
   * @function
   * @callback
   * @param {string} property - La propiedad del servicio que se va a actualizar. Las opciones son: 'envios', 'recargas', 'ventaEmpaques', 'pagoServicios', 'repartoMultimarcas'.
   * @param {number} value - El valor nuevo que se asignará a la propiedad.
   * @param {boolean} isAdmin - Un booleano que indica si el usuario es un administrador (true) o no (false).
   * @returns {void}
   */

  const updateUtilidades = useCallback(
    (property, value, isAdmin) => {
      if (isAdmin) {
        setUtilidadesPorServicioAdmin((prevState) => ({
          ...prevState,
          [property]: value
        }));
      } else {
        setUtilidadesPorServicioNonAdmin((prevState) => ({
          ...prevState,
          [property]: value
        }));
      }
    },
    [setUtilidadesPorServicioAdmin, setUtilidadesPorServicioNonAdmin]
  );

  const onShowNewDashboard = () => {
    setIsShowingNewDashboard((prev) => !prev);
  };

  return (
    <UtilidadesContext.Provider
      value={{
        getUtilidadesPorServicio,
        updateUtilidades,
        onShowNewDashboard,
        isShowingNewDashboard,
        codigosDigitales
      }}
    >
      {children}
    </UtilidadesContext.Provider>
  );
};

export const useUtilidades = () => {
  const context = useContext(UtilidadesContext);
  if (!context) {
    throw new Error('useUtilidades debe ser utilizado dentro de UtilidadesProvider');
  }
  return context;
};

export default UtilidadesProvider;
